import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SmallGrayText } from '@guryou/html-components';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Slider from '@material-ui/core/Slider';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles({
  root: ({ margin }) => ({
    width: '100%',
    margin: margin || '16px 16px 8px 16px',
    textAlign: 'start',
  }),
  input: {
    width: 50,
    '& input[type=number]::-webkit-inner-spin-button': {
      opacity: 1,
    },
  },
});

const WizardSlider = ({
  name,
  label,
  min = 0,
  max = 2000,
  maxSlider = 200,
  step = 1,
  icon,
  marks = null,
  defaultValue = 0,
  onBlur = null,
  allowEmpty = false,
  margin = null,
  onChange = null,
}) => {
  const classes = useStyles({ margin });
  const { t } = useTranslation();
  const [value, setValue] = React.useState(defaultValue);

  useEffect(() => {
    onChange && onChange(value);
  }, [onChange, value]);

  const handleSliderChange = (_, newValue) => {
    setValue(newValue);
  };

  const handleInputChange = event => {
    setValue(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleBlur = () => {
    if ((!value || value < min) && !allowEmpty) {
      setValue(min);
      onBlur && onBlur(min);
    } else if (value > max) {
      setValue(max);
      onBlur && onBlur(max);
    }
    onBlur && onBlur(value);
  };

  return (
    <div className={classes.root}>
      <SmallGrayText id="input-slider">{label}</SmallGrayText>
      <Grid container spacing={2} alignItems="center">
        {icon && <Grid item>{icon}</Grid>}
        <Grid item xs>
          <Slider
            value={typeof value === 'number' ? value : Number(value)}
            min={min}
            step={step}
            max={maxSlider}
            onChange={handleSliderChange}
            aria-labelledby="input-slider"
            marks={marks}
            onBlur={handleBlur}
          />
        </Grid>
        <Grid item>
          <Tooltip title={`${t('SERVICE_WIZARD.maximumValue')}${max}`}>
            <Input
              className={classes.input}
              variant="standard"
              value={value}
              disableUnderline={true}
              disabled={marks && true}
              name={name}
              type={marks ? 'text' : 'number'}
              margin="dense"
              onChange={handleInputChange}
              onBlur={handleBlur}
              inputProps={{
                step: step,
                min: min,
                max: max,
                'aria-labelledby': 'input-slider',
              }}
            />
          </Tooltip>
        </Grid>
      </Grid>
    </div>
  );
};

export default WizardSlider;
